import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  Alert,
} from "@mui/material";
import PCMCHeader from "../layout/pcmc-header";
import { validateOtp } from "../../services/user";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  clearSession,
  getUserDetails,
  setSession,
} from "../../utils/sessionUtils";
import Loader from "../loader/loader";
import { getErrorMsg } from "../../utils/helpers";
import { errorMsg } from "../../utils/constants";
import { showToastError } from "../common/toastHelper";
import ResendOTPButton from "./resend-otp";
import { CheckCircle } from "@mui/icons-material";

const VerifyOtp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const userInfo = useSelector((state) => state.userDetails.userInfo);
  const [formData, setFormData] = useState({
    otp: "",
  });

  useEffect(() => {
    const userDetails = getUserDetails();
    if (!userInfo.userCode) {
      clearSession();
      navigate("/login");
    } else if (userDetails.otpverified) {
      navigate("/home");
    } else {
      setLoading(false);
    }
  }, [navigate, userInfo]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setError("");
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { otp } = formData;
    setLoading(true);
    // Here, you would call your API with the form data
    validateOtp(userInfo.userCode, otp)
      .then((data) => {
        setLoading(false);
        if (data?.otpverified) {
          const userDetails = getUserDetails();
          setSession({ ...userDetails, otpverified: true });
          dispatch({ type: "RESET_MENU" });
          navigate("/home");
        }
      })
      .catch((error) => {
        showToastError(getErrorMsg(error));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // if (loading) {
  //   return null; // Return null while checking user details
  // }

  const isVerifyOtpDisabled = !formData.otp;

  return (
    <>
      {loading && <Loader message="Verifying OTP..." />}
      <PCMCHeader />
      <Container component="main" maxWidth="xs">
        <Box
          sx={{
            marginTop: 8,
            marginBottom: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            border: "2px solid #ccc",
            borderRadius: 2,
            p: 3,
            boxShadow: 3,
            bgcolor: "background.paper",
          }}
        >
          {error && <Alert severity="error">{error || errorMsg}</Alert>}
          <Typography component="div" mb={4}>
            Enter OTP (One Time Password) sent on your registered Mobile Number.
          </Typography>
          <Box
            component="form"
            noValidate
            sx={{ mt: 1 }}
            onSubmit={handleSubmit}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  autoFocus
                  variant="outlined"
                  required
                  fullWidth
                  id="otp"
                  label="Enter OTP"
                  name="otp"
                  autoComplete="otp"
                  size="small"
                  value={formData.otp}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} display="flex" justifyContent="space-between">
                <Button
                  type="submit"
                  variant="contained"
                  color="success"
                  disabled={isVerifyOtpDisabled}
                  endIcon={<CheckCircle />}
                >
                  Verify OTP
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    clearSession();
                    navigate("/login");
                  }}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item xs={12}>
                <ResendOTPButton />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default VerifyOtp;
